export const spacingOptions = [
  { label: '8px', value: '8px' },
  { label: '16px', value: '16px' },
  { label: '24px', value: '24px' },
  { label: '32px', value: '32px' },
  { label: '40px', value: '40px' },
  { label: '48px', value: '48px' },
  { label: '56px', value: '56px' },
  { label: '64px', value: '64px' },
  { label: '72px', value: '72px' },
  { label: '80px', value: '80px' },
  { label: '88px', value: '88px' },
  { label: '96px', value: '96px' },
  { label: '104px', value: '104px' },
  { label: '112px', value: '112px' },
  { label: '120px', value: '120px' },
  { label: '128px', value: '128px' },
  { label: '136px', value: '136px' },
  { label: '144px', value: '144px' },
  { label: '152px', value: '152px' },
  { label: '160px', value: '160px' },
];

export const flexDirections = [
  { label: 'Row', value: 'row' },
  { label: 'Row Reverse', value: 'row-reverse' },
  { label: 'Column', value: 'column' },
  { label: 'Column Reverse', value: 'column-reverse' },
];

export const boxShadows = [
  { label: 'None', value: 'none' },
  { label: 'Light Soft Shadow', value: 'shadow-md' },
  { label: 'Medium Soft Shadow', value: 'shadow-lg' },
  { label: 'Heavy Soft Shadow', value: 'shadow-xl' },
  { label: 'Blurred Soft Shadow', value: 'shadow-2xl' },
];

export const verticalAligns = [
  { label: 'Stretch', value: 'justify-stretch' },
  { label: 'Start', value: 'justify-start' },
  { label: 'Center', value: 'justify-center' },
  { label: 'End', value: 'justify-end' },
];

export const fontFamilies = [
  {
    label: 'Shopify Dawn (Stack)',
    value: `"HelveticaNeue", "helvetica", "arial", sans-serif`,
  },
  {
    label: 'Narrative (Stack)',
    value: `"Kollektif", sans-serif`,
  },
  {
    label: 'Infinity – Mystic (Stack)',
    value: `"inter", sans-serif`,
  },
  {
    label: 'Infinity – Radiant (Stack)',
    value: `"dmsans", sans-serif`,
  },
  {
    label: 'Combine (Krown Themes - Stack)',
    value: `var(--font-stack-headings-primary), var(--font-stack-body-primary)`,
  },
  {
    label: 'Kingdom (Krown Themes - Stack)',
    value: `var(--font-stack-headings), var(--font-stack-body)`,
  },
  {
    label: 'Inter (Stack)',
    value: `"inter", "helvetica", "arial", sans-serif`,
  },
  {
    label: 'System UI (Stack)',
    value: `-apple-system, system-ui, "SegoeUI", roboto, helvetica, arial, sans-serif`,
  },
  {
    label: 'Full System UI + Emoji (Stack)',
    value: `-apple-system, system-ui, "SegoeUI", roboto, helvetica, arial, sans-serif, "AppleColorEmoji", "SegoeUIEmoji", "SegoeUISymbol"`,
  },
  {
    label: 'Clean Sans (Stack)',
    value: `"HelveticaNeue", helvetica, arial, sans-serif`,
  },
  {
    label: 'Classic Serif (Stack)',
    value: `georgia, "timesNewRoman", times, serif`,
  },
  {
    label: 'Modern Sans (Stack)',
    value: `"SegoeUI", roboto, "HelveticaNeue", arial, sans-serif`,
  },
  {
    label: 'Rounded (Stack)',
    value: `"nunito", "Quicksand", arial, sans-serif`,
  },
  {
    label: 'Neutral (Stack)',
    value: `arial, sans-serif`,
  },
  {
    label: 'Editorial Serif (Stack)',
    value: `"merriweather", georgia, serif`,
  },
  {
    label: 'Code/Mono (Stack)',
    value: `"couriernew", courier, monospace`,
  },
  {
    label: 'Open Sans (Stack)',
    value: `"opensans", "HelveticaNeue", arial, sans-serif`,
  },
  {
    label: 'Apple System',
    value: `-apple-system, BlinkMacSystemFont, 'SegoeUI', 'roboto', 'HelveticaNeue', arial, sans-serif`,
  },
  {
    label: 'System ui',
    value: `system-ui, -apple-system, BlinkMacSystemFont, "SegoeUI", roboto, 'HelveticaNeue', arial, sans-serif`,
  },
  {
    label: 'Sans-serif',
    value: 'sans-serif',
  },
  {
    label: 'Fantasy',
    value: 'fantasy',
  },
  {
    label: 'Monospace',
    value: 'monospace',
  },
  {
    label: 'Serif',
    value: 'serif',
  },
  {
    label: 'Times New Roman',
    value: 'timesNewRoman',
  },
  {
    label: 'Georgia',
    value: 'georgia',
  },

  {
    label: 'Baskerville',
    value: 'baskerville',
  },
  {
    label: 'Merriweather',
    value: 'merriweather',
  },
  {
    label: 'Arial',
    value: 'arial',
  },
  {
    label: 'Helvetica',
    value: 'helvetica',
  },
  {
    label: 'Verdana',
    value: 'verdana',
  },
  {
    label: 'Tahoma',
    value: 'tahoma',
  },
  {
    label: 'Roboto',
    value: 'roboto',
  },
  {
    label: 'Consolas',
    value: 'consolas',
  },
  {
    label: 'Pacifico',
    value: 'pacifico',
  },
  {
    label: 'Lobster',
    value: 'lobster',
  },
  {
    label: 'Inter',
    value: 'inter',
  },
  {
    label: 'Cabin',
    value: 'cabin',
  },
  {
    label: 'Playball',
    value: 'playball',
  },
  {
    label: 'Abel',
    value: 'abel',
  },
  {
    label: 'AbrilFatface',
    value: 'abrilfatface',
  },
  {
    label: 'Alegreya',
    value: 'alegreya',
  },
  {
    label: 'Aleo',
    value: 'aleo',
  },
  {
    label: 'Amiri',
    value: 'amiri',
  },
  {
    label: 'Anonymous Pro',
    value: 'anonymouspro',
  },
  {
    label: 'Arapey',
    value: 'arapey',
  },
  {
    label: 'Archivo',
    value: 'archivo',
  },
  {
    label: 'Archivo Narrow',
    value: 'archivonarrow',
  },
  {
    label: 'Arimo',
    value: 'arimo',
  },
  {
    label: 'Arsenal',
    value: 'arsenal',
  },
  {
    label: 'Arvo',
    value: 'arvo',
  },
  {
    label: 'AlegreyaSans',
    value: 'alegreyasans',
  },
  {
    label: 'Assistant',
    value: 'assistant',
  },
  {
    label: 'Asul',
    value: 'asul',
  },
  {
    label: 'Bevan',
    value: 'bevan',
  },
  {
    label: 'Bitter',
    value: 'bitter',
  },
  {
    label: 'Bodoni Moda',
    value: 'bodonimoda',
  },
  {
    label: 'Bricolage Grotesque',
    value: 'bricolagegrotesque',
  },
  {
    label: 'Cardo',
    value: 'cardo',
  },
  {
    label: 'Catamaran',
    value: 'catamaran',
  },
  {
    label: 'Chivo',
    value: 'chivo',
  },
  {
    label: 'Cormorant',
    value: 'cormorant',
  },
  {
    label: 'Courier New',
    value: 'couriernew',
  },
  {
    label: 'Crimson Text',
    value: 'crimsontext',
  },
  {
    label: 'DM Sans',
    value: 'dmsans',
  },
  {
    label: 'Domine',
    value: 'domine',
  },
  {
    label: 'Dosis',
    value: 'dosis',
  },
  {
    label: 'EB Garamond',
    value: 'ebgaramond',
  },
  {
    label: 'Eczar',
    value: 'eczar',
  },
  {
    label: 'Fahkwang',
    value: 'fahkwang',
  },
  {
    label: 'Figtree',
    value: 'figtree',
  },
  {
    label: 'Fira Sans',
    value: 'firasans',
  },
  {
    label: 'Fjalla One',
    value: 'fjallaone',
  },
  {
    label: 'Fraunces',
    value: 'fraunces',
  },
  {
    label: 'Gluten',
    value: 'gluten',
  },
  {
    label: 'Grandstander',
    value: 'grandstander',
  },
  {
    label: 'Hepta Slab',
    value: 'heptaslab',
  },
  {
    label: 'IBM Plex Sans',
    value: 'ibmplexsans',
  },
  {
    label: 'Inconsolata',
    value: 'inconsolata',
  },
  {
    label: 'Inknut Antiqua',
    value: 'inknutantiqua',
  },
  {
    label: 'Instrument Sans',
    value: 'instrumentsans',
  },
  {
    label: 'Josefin Sans',
    value: 'josefinsans',
  },
  {
    label: 'Josefin Slab',
    value: 'josefinslab',
  },
  {
    label: 'Jost',
    value: 'jost',
  },
  {
    label: 'Kalam',
    value: 'kalam',
  },
  {
    label: 'Karla',
    value: 'karla',
  },
  {
    label: 'Kaushan Script',
    value: 'kaushanscript',
  },
  {
    label: 'Klee One',
    value: 'kleeone',
  },
  {
    label: 'Kreon',
    value: 'kreon',
  },
  {
    label: 'Libre Bodoni',
    value: 'librebodoni',
  },
  {
    label: 'Libre Caslon Text',
    value: 'librecaslontext',
  },
  {
    label: 'Libre Franklin',
    value: 'librefranklin',
  },
  {
    label: 'Lora',
    value: 'lora',
  },
  {
    label: 'Lucida Grande',
    value: 'lucidagrande',
  },
  {
    label: 'Manuale',
    value: 'manuale',
  },
  {
    label: 'Maven Pro',
    value: 'mavenpro',
  },
  {
    label: 'Montserrat',
    value: 'montserrat',
  },
  {
    label: 'Muli',
    value: 'muli',
  },
  {
    label: 'Neuton',
    value: 'neuton',
  },
  {
    label: 'Newsreader',
    value: 'newsreader',
  },
  {
    label: 'Nobile',
    value: 'nobile',
  },
  {
    label: 'Noto Serif',
    value: 'notoserif',
  },
  {
    label: 'Nunito',
    value: 'nunito',
  },
  {
    label: 'Nunito Sans',
    value: 'nunitosans',
  },
  {
    label: 'Old Standard TT',
    value: 'OldStandardTT',
  },
  {
    label: 'Open Sans',
    value: 'opensans',
  },
  {
    label: 'Oswald',
    value: 'oswald',
  },
  {
    label: 'Ovo',
    value: 'ovo',
  },
  {
    label: 'Palatino',
    value: 'palatino',
  },
  {
    label: 'Petrona',
    value: 'petrona',
  },
  {
    label: 'Pinyon Script',
    value: 'pinyonscript',
  },
  {
    label: 'Platypi',
    value: 'Platypi',
  },
  {
    label: 'Playfair',
    value: 'playfair',
  },
  {
    label: 'Poppins',
    value: 'poppins',
  },
  {
    label: 'Playpen Sans',
    value: 'playpensans',
  },
  {
    label: 'Prompt',
    value: 'prompt',
  },
  {
    label: 'Proza Libre',
    value: 'prozalibre',
  },
  {
    label: 'PT Sans',
    value: 'PTSans',
  },
  {
    label: 'PT Serif',
    value: 'PTSerif',
  },
  {
    label: 'Quantico',
    value: 'Quantico',
  },
  {
    label: 'Quattrocento Sans',
    value: 'QuattrocentoSans',
  },
  {
    label: 'Questrial',
    value: 'Questrial',
  },
  {
    label: 'Quicksand',
    value: 'Quicksand',
  },
  {
    label: 'Rajdhani',
    value: 'Rajdhani',
  },
  {
    label: 'Raleway',
    value: 'Raleway',
  },
  {
    label: 'Rasa',
    value: 'Rasa',
  },
  {
    label: 'Roboto',
    value: 'Roboto',
  },
  {
    label: 'Roboto Black',
    value: 'RobotoBlack',
  },
  {
    label: 'Roboto Condensed',
    value: 'RobotoCondensed',
  },
  {
    label: 'Roboto Mono',
    value: 'RobotoMono',
  },
  {
    label: 'Roboto Slab',
    value: 'RobotoSlab',
  },
  {
    label: 'Rubik',
    value: 'Rubik',
  },
  {
    label: 'Saira',
    value: 'Saira',
  },
  {
    label: 'Shadows Into Light',
    value: 'ShadowsIntoLight',
  },
  {
    label: 'Smooch',
    value: 'Smooch',
  },
  {
    label: 'Source Code Pro',
    value: 'SourceCodePro',
  },
  {
    label: 'Source Sans Pro',
    value: 'SourceSansPro',
  },
  {
    label: 'Space Mono',
    value: 'SpaceMono',
  },
  {
    label: 'Syne',
    value: 'Syne',
  },
  {
    label: 'Tenor Sans',
    value: 'TenorSans',
  },
  {
    label: 'Titillium Web',
    value: 'TitilliumWeb',
  },
  {
    label: 'Tomorrow',
    value: 'Tomorrow',
  },
  {
    label: 'Trebuchet MS',
    value: 'TrebuchetMS',
  },
  {
    label: 'Trirong',
    value: 'Trirong',
  },
  {
    label: 'Ubuntu',
    value: 'Ubuntu',
  },
  {
    label: 'Unica One',
    value: 'UnicaOne',
  },
  {
    label: 'UnifrakturCook',
    value: 'UnifrakturCook',
  },
  {
    label: 'UnifrakturMaguntia',
    value: 'UnifrakturMaguntia',
  },
  {
    label: 'Work Sans',
    value: 'WorkSans',
  },
  {
    label: 'Yrsa',
    value: 'Yrsa',
  },
  {
    label: 'Zilla Slab',
    value: 'ZillaSlab',
  },
  {
    label: 'BIZUDPMincho',
    value: 'BIZUDPMincho',
  },
  {
    label: 'DelaGothicOne',
    value: 'DelaGothicOne',
  },
  {
    label: 'HinaMincho',
    value: 'HinaMincho',
  },
  {
    label: 'KaiseiOpti',
    value: 'KaiseiOpti',
  },
  {
    label: 'KaiseiTokumin',
    value: 'KaiseiTokumin',
  },
  {
    label: 'MPLUS 1p',
    value: 'MPLUS',
  },
  {
    label: 'M PLUS Rounded 1c',
    value: 'MPLUSRounded1c',
  },
  {
    label: 'Mochiy Pop P One',
    value: 'MochiyPopPOne',
  },
  {
    label: 'Murecho',
    value: 'Murecho',
  },
  {
    label: 'Noto Sans Japanese',
    value: 'NotoSansJapanese',
  },
  {
    label: 'Noto Serif Japanese',
    value: 'NotoSerifJapanese',
  },
  {
    label: 'Zen Kaku New',
    value: 'ZenKakuNew',
  },
  {
    label: 'ZenKurenaido',
    value: 'ZenKurenaido',
  },
  {
    label: 'Zen Maru Gothic',
    value: 'ZenMaruGothic',
  },
  {
    label: 'Zen Old Mincho',
    value: 'ZenOldMincho',
  },
  {
    label: 'Gill Sans',
    value: 'GillSans',
  },
  {
    label: 'Frutiger',
    value: 'Frutiger',
  },
  {
    label: 'Myriad Pro',
    value: 'MyriadPro',
  },
  {
    label: 'Optima',
    value: 'Optima',
  },
  {
    label: 'Segoe UI',
    value: 'SegoeUI',
  },
  {
    label: 'Verdana',
    value: 'Verdana',
  },
  {
    label: 'Lucida Grande',
    value: 'lucidasans',
  },
  {
    label: 'Calibri',
    value: 'calibri',
  },
  {
    label: 'Noto Sans',
    value: 'NotoSans',
  },
  {
    label: 'Blink MacSystem',
    value: 'BlinkMacSystem',
  },
  {
    label: 'San Francisco',
    value: 'SanFrancisco',
  },
  {
    label: 'Helvetica Neue',
    value: 'HelveticaNeue',
  },
  {
    label: 'SF Pro',
    value: 'SFPro',
  },
  {
    label: 'SF Compact',
    value: 'SFCompact',
  },
  {
    label: 'SF Mono',
    value: 'SFMono',
  },
  {
    label: 'New York',
    value: 'NewYork',
  },
  {
    label: 'Kollektif',
    value: 'Kollektif',
  },
  {
    label: 'Segoe UI Emoji',
    value: 'SegoeUIEmoji',
  },
  {
    label: 'Segoe UI Symbol',
    value: 'SegoeUISymbol',
  },
  {
    label: 'Apple Color Emoji',
    value: 'AppleColorEmoji',
  },
  {
    label: 'Times',
    value: 'times',
  },
  {
    label: 'Courier',
    value: 'courier',
  },
];

export const countries = [
  { value: '', label: 'Select Country' },
  { value: 'US', label: 'United States' },
  { value: 'AF', label: 'Afghanistan' },
  { value: 'AU', label: 'Australia' },
  { value: 'AT', label: 'Austria' },
  { value: 'BE', label: 'Belgium' },
  { value: 'CA', label: 'Canada' },
  { value: 'CZ', label: 'Czech Republic' },
  { value: 'DK', label: 'Denmark' },
  { value: 'FI', label: 'Finland' },
  { value: 'FR', label: 'France' },
  { value: 'DE', label: 'Germany' },
  { value: 'HK', label: 'Hong Kong' },
  { value: 'IN', label: 'India' },
  { value: 'IE', label: 'Ireland' },
  { value: 'IL', label: 'Israel' },
  { value: 'IT', label: 'Italy' },
  { value: 'JP', label: 'Japan' },
  { value: 'MY', label: 'Malaysia' },
  { value: 'NL', label: 'Netherlands' },
  { value: 'NZ', label: 'New Zealand' },
  { value: 'NO', label: 'Norway' },
  { value: 'PL', label: 'Poland' },
  { value: 'PT', label: 'Portugal' },
  { value: 'SG', label: 'Singapore' },
  { value: 'KR', label: 'South Korea' },
  { value: 'ES', label: 'Spain' },
  { value: 'SE', label: 'Sweden' },
  { value: 'CH', label: 'Switzerland' },
  { value: 'AE', label: 'United Arab Emirates' },
  { value: 'GB', label: 'United Kingdom' },
];

export const phone_codes = [
  { value: '', label: 'Select Country for Phonecode' },
  { value: '1', label: 'United States' },
  { value: '93', label: 'Afghanistan' },
  { value: '61', label: 'Australia' },
  { value: '43', label: 'Austria' },
  { value: '32', label: 'Belgium' },
  { value: '1', label: 'Canada' },
  { value: '420', label: 'Czech Republic' },
  { value: '45', label: 'Denmark' },
  { value: '358', label: 'Finland' },
  { value: '33', label: 'France' },
  { value: '49', label: 'Germany' },
  { value: '852', label: 'Hong Kong' },
  { value: '91', label: 'India' },
  { value: '353', label: 'Ireland' },
  { value: '972', label: 'Israel' },
  { value: '39', label: 'Italy' },
  { value: '81', label: 'Japan' },
  { value: '60', label: 'Malaysia' },
  { value: '31', label: 'Netherlands' },
  { value: '64', label: 'New Zealand' },
  { value: '47', label: 'Norway' },
  { value: '48', label: 'Poland' },
  { value: '351', label: 'Portugal' },
  { value: '65', label: 'Singapore' },
  { value: '82', label: 'South Korea' },
  { value: '34', label: 'Spain' },
  { value: '46', label: 'Sweden' },
  { value: '41', label: 'Switzerland' },
  { value: '971', label: 'United Arab Emirates' },
  { value: '44', label: 'United Kingdom' },
];
